import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useDashboardType } from '../hooks/useBrands';
import { Box, CircularProgress } from '@mui/material';

/**
 * Component solely responsible for redirecting from /org/:orgId 
 * to the appropriate default dashboard page based on dashboardType.
 */
const OrgRedirector: React.FC = () => {
    const { orgId } = useParams<{ orgId: string }>();
    const orgIdNum = parseInt(orgId || '0', 10);
    const { dashboardType, loading, error } = useDashboardType(orgIdNum);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error || !orgId) {
        // Handle error or missing orgId, maybe redirect to a generic error page or login
        // For now, redirecting to root which goes to default org
        console.error("Error fetching dashboard type or missing orgId:", error);
        return <Navigate to="/" replace />;
    }

    const defaultRoute = dashboardType === 'personal_branding' 
        ? 'employee-brand/general'
        : 'brand-tracker';

    return <Navigate to={`/org/${orgId}/${defaultRoute}`} replace />;
};

export default OrgRedirector; 